import * as React from 'react';
import { Sticky } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { useCmsData, ProductDetailTitleView, ProductDetailPrice, ProductDiscountLabel, Discount, SizeGuideModalView, NonRxProductCTA, TryOnButton, ProductDetailUsps, ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import { StockIndicator } from '@grandvisionhq/inventory';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import { useFeatureToggles } from '@grandvisionhq/state';
import { PowerSelector } from './components/PowerSelector/PowerSelector.js';
import { ReadyReadersFeatures } from './components/ReadyReaderFeatures/ReadyReadersFeatures.js';
import { ProductImageGalleryContainer } from '../../ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';
import { ProductDetailSpecificationContainer } from '../../ProductDetailSpecification/ProductDetailSpecificationContainer.js';

const ReadyReaders = ({ activeSku , activeVariant , addToCartRef , brandLink , currency , handleConversionEvent , handleVariantPick , isMobile , isOrderable , isProductLabelEnabled , labels , onCTAClick , productImageAlt , stickyTop , stockCount , variant , variants , storesRoute  })=>{
    const { isFrameSizeVTOEnabled , featureConfigs  } = useFeatureToggles();
    const { channelAvailability  } = variant;
    const { sizeGuideDocument , usps: productTypeUsps  } = useCmsData();
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-ready-readers"
    }, isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), /*#__PURE__*/ React.createElement("aside", {
        className: "product-detail__aside"
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isMobile
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    })), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), !!variant.price && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: variant.price.originalPrice,
        discountedPrice: variant.price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    })), !isMobile && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-ready-readers__power_selector"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-ready-readers__label"
    }, labels.power, /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: stockCount,
        allowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    })), /*#__PURE__*/ React.createElement(PowerSelector, {
        handleVariantPick: handleVariantPick,
        variants: variants,
        activeSku: activeSku
    })), sizeGuideDocument && /*#__PURE__*/ React.createElement(SizeGuideModalView, {
        sku: activeSku,
        productName: productImageAlt,
        isVtoEnabled: !!activeVariant.vtoEnabled && isFrameSizeVTOEnabled,
        sizeGuideContent: sizeGuideDocument
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            onSuccess: onCTAClick
        }
    })), activeVariant.vtoEnabled && featureConfigs.virtualTryOn === 'DITTO' && /*#__PURE__*/ React.createElement(TryOnButton, null), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, null)))))), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-ready-readers__description",
        "aria-label": "product-information-block",
        "data-t": "ready-readers-description"
    }, /*#__PURE__*/ React.createElement(ReadyReadersFeatures, {
        variant: variant,
        labels: labels
    }), /*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        header: variant.header,
        description: variant.description,
        usps: variant.usps
    }), /*#__PURE__*/ React.createElement(ProductDetailSpecificationContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer"
    }));
};

export { ReadyReaders };
//# sourceMappingURL=ReadyReaders.js.map
